export interface VersionConfig {
  targetVersions: Record<string, string>;
  sourceVersions: Record<string, string>;
}

export const DEFAULT_VERSION_CONFIG: VersionConfig = {
  targetVersions: { '19': '19.31', '21': '21.22', '23': '23.26.2', '26': '23.26.2' },
  sourceVersions: { '23': '23.9', '26': '23.9' },
};

export async function loadVersionConfig(): Promise<VersionConfig> {
  try {
    const res = await fetch('/versionConfig.json');
    if (res.ok) return await res.json();
  } catch {}
  return DEFAULT_VERSION_CONFIG;
}

export const getTargetVersion = (config: VersionConfig, major: string): string =>
  config.targetVersions[major] ?? config.targetVersions['19'];

export const getSourceVersion = (config: VersionConfig, major: string): string =>
  config.sourceVersions[major] ?? config.sourceVersions['23'];
